<template>
    <Popup
            v-model="popupShow"
            position="bottom"
            radius="5px"
            class="select-device-popup"
    >
        <div class="popup-bar">
            <div class="cancel" @click="onCancel">取消</div>
            <div class="title"> 请选择设备</div>
            <div class="ok" @click="onOk">确定</div>
        </div>
        <div class="content">
            <Search v-model="searchInput" @search="deviceSearch"
                    placeholder="查找设备"/>
            <PullRefresh v-model="isReFresh" @refresh="onRefresh">
                <List
                        style="height: 100%;margin-top:-5px;padding: 5px 12px"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        loading-text="拼命加载中..."
                        @load="onLoad"
                        :offset="50"
                        :immediate-check="true"
                >
                    <div v-for="(item, index) in deviceList" :key="index"
                         @click="onSelect(item)"
                         :class="{'device-item':true,'selected':selected.id==item.id} ">
                        <img :src="getImgUrl(item.productImage1)"/>
                        <div class="right">
                            <div class="device-name">{{item.name}}</div>
                            <div class="product-name">{{item.productName}}</div>
                        </div>
                    </div>
                </List>
            </PullRefresh>
        </div>
    </Popup>
</template>

<script>
    import {List, Popup, PullRefresh, Search, Sticky} from "vant"
    import {downloadImg} from "@/config"

    export default {
        components: {
            Popup, PullRefresh, Search, List, Sticky
        },
        props: {
            show: {type: Boolean, default: false},
        },
        data() {
            return {
                isReFresh: false,
                finished: false,
                searchInput: null,
                loading: false,
                deviceList: [],
                selected: {}
            }
        },
        computed: {
            popupShow: {
                get() {
                    return this.show
                },
                set() {
                    this.onCancel()
                }
            },
        },
        methods: {
            onCancel() {
                this.$emit('cancel')
            },
            onOk() {
                this.$emit('ok', this.selected)
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.device.list({
                    fullText: this.searchInput,
                    size: 20,
                    page: Math.ceil(this.deviceList.length / 20 + 1)
                })
                    .then(res => {
                        if (res) {
                            this.deviceList.push(...res.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            // 数据全部加载完成
                            if (this.deviceList.length >= res.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
            onRefresh() {
                this.searchPanel = false;
                this.isReFresh = true;
                this.deviceList = [];
                this.onLoad(true);
            },
            deviceSearch() {
                this.deviceList = [];
                this.onLoad();
            },
            getImgUrl(url) {
                return downloadImg + url
            },
            onSelect(device) {
                this.selected = device
            }
        }
    };
</script>
<style lang="less" scoped>
    .select-device-popup {
        height: calc(100% - 140px);
        & > .content {
            display: flex;
            flex-direction: column;
            height: calc(100% - 50px);
            & > .van-search {

            }
            & > .van-pull-refresh {
                height: calc(100% - 50px);
                overflow-y: auto;

            }
        }
    }

    .device-item {

        &.selected {
            border: 1px solid rgba(24, 144, 255, 1);
        }
        padding: 5px;
        display: flex;
        border-radius: 5px;
        border: 1px solid rgba(111, 111, 111, 0.3);
        margin-top: 2px;
        margin-bottom: 5px;
        & > img {
            height: 50px;
            width: 50px;
        }
        & > .right {
            margin-left: 8px;
            line-height: 1.5;
            & > .device-name {
                font-weight: 500;
                font-size: 18px;
            }
            & > .product-name {
                color: #999;
                font-size: 15px;
            }
        }
    }
</style>
